module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"waitlist_outcome":"Waitlist Outcome"},"fr":{"waitlist_outcome":"Résultat de la liste d\u0027attente"}}')
  delete Component.options._Ctor
}
